import { z } from 'zod'

export const SubTypeSchema = z.object({
  id: z.number(),
  source_type: z.number(),
  name: z.string(),
})

export const FundingSourceSchema = z.object({
  id: z.number(),
  name: z.string(),
  sub_types: z.array(SubTypeSchema),
})

export type FundingSource = z.infer<typeof FundingSourceSchema>
